var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetTransfer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 468,
    height: 414,
    viewBox: "0 0 468 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "get-transfer",
    transform: "translate(-819 -1798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1132",
    "data-name": "Rectangle 1132",
    width: 468,
    height: 414,
    transform: "translate(819 1798)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "get-transfer-2",
    "data-name": "get-transfer",
    transform: "translate(818.993 1798.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M516.7,257.891s-7.131-.519-6.472,15.483,2.284,24.519,2.284,24.519-.206,3.545-2.96,2.853-7.915-4.122-10.462-1.575-1.707,6.785,1.806,11.617,10.817,15.714,11.468,16.7.907,2.778-1.039,2.605-15.1-4.633-16.835,1.731,10.256,18.229,11.542,19.548,1.352,2.16.824,2.96-4.8-1.113-8.591-2.226-8.385-1.748-9.069,2.012,4.584,14.749,24.371,26.3l9.522,4.749,9-5.771c18.534-13.471,22.689-24.931,21.625-28.6s-5.573-2.589-9.234-1.1-7.725,3.817-8.327,3.075-.61-1.583.536-3.026,11.9-14.444,9.531-20.611-15.005-.412-16.926-.041-1.847-1.467-1.3-2.473,6.736-12.6,9.745-17.767,3.537-9.341.635-11.732-7.593,1.649-10.256,2.605-3.224-2.539-3.224-2.539.767-8.649-.181-24.626-8.162-14.692-8.162-14.692",
    transform: "translate(-85.873 -45.265)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M523.25,275.27a2.825,2.825,0,0,1,0,.338c0,.239.041.561.074.981.058.882.148,2.152.256,3.776.223,3.3.5,8.03.824,13.9.651,11.748,1.418,27.974,2.2,45.9s1.5,34.157,2.086,45.9c.3,5.862.544,10.611.709,13.909.083,1.649.148,2.9.19,3.784v.981a5.343,5.343,0,0,0-.074-.981c-.058-.882-.148-2.152-.256-3.776-.223-3.3-.5-8.03-.824-13.9-.651-11.74-1.418-27.974-2.2-45.9s-1.5-34.149-2.086-45.9c-.3-5.862-.544-10.6-.709-13.908-.082-1.649-.148-2.894-.19-3.776V275.27Z",
    transform: "translate(-91.861 -48.323)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M509.74,314.18a3.493,3.493,0,0,1,.594.495c.363.338.882.824,1.509,1.451,1.253,1.245,2.943,3.009,4.774,5l4.658,5.087c.552.6,1.022,1.121,1.418,1.542a3.7,3.7,0,0,1,.495.585,3.3,3.3,0,0,1-.6-.486c-.363-.338-.874-.824-1.5-1.459-1.245-1.261-2.91-3.042-4.732-5.029l-4.691-5.054-1.426-1.533A2.776,2.776,0,0,1,509.74,314.18Z",
    transform: "translate(-89.489 -55.154)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M527.19,327.587c-.066-.074,3.413-3.718,7.775-8.137s7.964-7.964,8.038-7.89-3.413,3.718-7.775,8.146S527.264,327.637,527.19,327.587Z",
    transform: "translate(-92.552 -54.693)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M527.14,362.213a3.548,3.548,0,0,1,.668-.429l1.863-1.039c1.566-.882,3.735-2.111,6.076-3.553s4.419-2.8,5.92-3.8l1.773-1.187a3.676,3.676,0,0,1,.676-.4,2.967,2.967,0,0,1-.594.519c-.4.313-.973.75-1.707,1.278-1.467,1.064-3.529,2.473-5.878,3.908s-4.543,2.638-6.142,3.463c-.824.412-1.459.734-1.921.948A4.115,4.115,0,0,1,527.14,362.213Z",
    transform: "translate(-92.544 -61.758)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M508,352.72a2.862,2.862,0,0,1,.66.3l1.723.965c1.451.824,3.438,1.979,5.623,3.3s4.122,2.473,5.573,3.372c.7.437,1.278.824,1.649,1.055a2.7,2.7,0,0,1,.585.437,3,3,0,0,1-.66-.313c-.412-.214-1-.544-1.723-.956-1.451-.824-3.438-1.987-5.631-3.3s-4.122-2.473-5.565-3.38c-.709-.437-1.278-.824-1.649-1.055a2.954,2.954,0,0,1-.585-.429Z",
    transform: "translate(-89.184 -61.919)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M504.22,382.25a4.2,4.2,0,0,1,.824.4l2.218,1.22c1.863,1.047,4.419,2.473,7.239,4.122s5.359,3.141,7.189,4.238l2.135,1.352a3.951,3.951,0,0,1,.767.528,5.243,5.243,0,0,1-.824-.4l-2.21-1.229c-1.863-1.039-4.427-2.473-7.239-4.122s-5.359-3.141-7.189-4.246l-2.16-1.319A5.765,5.765,0,0,1,504.22,382.25Z",
    transform: "translate(-88.52 -67.103)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M528.48,393.2a4.555,4.555,0,0,1,.824-.561l2.317-1.4c1.946-1.2,4.642-2.844,7.56-4.749s5.532-3.694,7.42-5l2.226-1.542a5.678,5.678,0,0,1,.824-.536,5.063,5.063,0,0,1-.759.651c-.5.4-1.237.956-2.16,1.649-1.839,1.36-4.419,3.191-7.354,5.1s-5.639,3.529-7.634,4.658c-.989.569-1.806,1.014-2.374,1.311A5.576,5.576,0,0,1,528.48,393.2Z",
    transform: "translate(-92.779 -66.605)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M540.223,416.06H513.89l8.591,65.057h9.143Z",
    transform: "translate(-90.218 -73.038)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M515.54,425.195s0,.091.148.231a1.534,1.534,0,0,0,.635.453,3.182,3.182,0,0,0,2.778-.338c1.064-.585,1.987-1.74,3.413-2.251a7.511,7.511,0,0,1,4.84.1,20.822,20.822,0,0,1,4.51,2.185,31.856,31.856,0,0,0,3.669,1.97,10.3,10.3,0,0,0,2.7.775,5.053,5.053,0,0,0,.767.058h.264a13.627,13.627,0,0,1-3.611-1.088,35.867,35.867,0,0,1-3.586-2.028A19.962,19.962,0,0,0,527.486,423a7.775,7.775,0,0,0-5.112-.058,6.6,6.6,0,0,0-1.921,1.2,15.928,15.928,0,0,1-1.509,1.162,3.067,3.067,0,0,1-2.564.445,2.622,2.622,0,0,1-.841-.552Z",
    transform: "translate(-90.507 -74.176)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M516.709,439.284a8.825,8.825,0,0,1,.618-.7,5.847,5.847,0,0,1,2.1-1.336,9.471,9.471,0,0,1,3.669-.552,38.994,38.994,0,0,1,4.576.627,15.665,15.665,0,0,0,4.691.19,12.752,12.752,0,0,0,3.693-1.047,12.076,12.076,0,0,0,2.218-1.319,3.559,3.559,0,0,0,.709-.635,24.025,24.025,0,0,1-3.05,1.649,13.449,13.449,0,0,1-3.611.94,16.184,16.184,0,0,1-4.576-.231,36.532,36.532,0,0,0-4.642-.594,9.17,9.17,0,0,0-3.784.668,5.574,5.574,0,0,0-2.119,1.5,4.06,4.06,0,0,0-.4.585C516.734,439.193,516.693,439.275,516.709,439.284Z",
    transform: "translate(-90.712 -76.277)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M538.051,447.692a2.012,2.012,0,0,0-.725-.379,7.594,7.594,0,0,0-2.185-.47,13.8,13.8,0,0,0-3.3.19c-1.228.2-2.548.536-3.924.824a16.953,16.953,0,0,1-3.924.445,8.84,8.84,0,0,1-3.117-.676,7.321,7.321,0,0,1-2.358-1.756,1.945,1.945,0,0,0,.445.684,5.53,5.53,0,0,0,1.789,1.344,8.419,8.419,0,0,0,3.224.824A15.766,15.766,0,0,0,528,448.3c1.4-.3,2.7-.643,3.908-.866a15.59,15.59,0,0,1,3.215-.272A11.538,11.538,0,0,1,538.051,447.692Z",
    transform: "translate(-91.031 -78.272)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M519.53,458.675a4.246,4.246,0,0,1,2.556-.256,12.259,12.259,0,0,1,2.679,1,10.148,10.148,0,0,0,3.471.956,10.4,10.4,0,0,0,6.3-1.459A8.441,8.441,0,0,0,536.1,457.7c.322-.338.486-.536.462-.552a23.788,23.788,0,0,1-2.177,1.5,10.777,10.777,0,0,1-6.109,1.294c-2.473-.14-4.411-1.649-6.142-1.83a4.007,4.007,0,0,0-1.987.173,1.3,1.3,0,0,0-.618.387Z",
    transform: "translate(-91.208 -80.252)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M521.31,473.4a5.071,5.071,0,0,0,2.193-.437c1.327-.445,2.968-1.459,4.881-2.218a7.724,7.724,0,0,1,2.795-.585,5.094,5.094,0,0,1,2.251.511,4.946,4.946,0,0,1,1.649,1.4,1.037,1.037,0,0,0-.247-.552,3.735,3.735,0,0,0-1.237-1.121,5.17,5.17,0,0,0-2.383-.635,7.743,7.743,0,0,0-2.96.577c-1.979.824-3.57,1.839-4.831,2.333S521.3,473.322,521.31,473.4Z",
    transform: "translate(-91.52 -82.465)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M522.88,481.206a6.044,6.044,0,0,0,1.649.544,28.851,28.851,0,0,0,4.163.7,29.917,29.917,0,0,0,4.229.124,5.945,5.945,0,0,0,1.74-.206c0-.132-2.671,0-5.92-.346S522.913,481.083,522.88,481.206Z",
    transform: "translate(-91.796 -84.472)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M359.569,202.37l50.753,28.1-1.9,3.586L358.11,205.42l1.459-3.05",
    transform: "translate(-62.871 -35.526)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M356.85,198.38l2.333-3.57,1.36.841-2.094,3.6Z",
    transform: "translate(-62.65 -34.198)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M412.34,231.07l2.605,1.5-8.5,54.232-4.015.049Z",
    transform: "translate(-70.651 -40.564)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M388.24,304.285s6.183-6.266,14.477-5.771a17.973,17.973,0,0,1,12.54,5.771Z",
    transform: "translate(-68.16 -52.399)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M352.63,223.153l-20.1-11.608L338.3,201.5a11.6,11.6,0,0,1,15.846-4.254h0a11.608,11.608,0,0,1,4.246,15.854Z",
    transform: "translate(-58.38 -34.354)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1028",
    "data-name": "Rectangle 1028",
    width: 64.39,
    height: 3.133,
    transform: "translate(178.727 249.232) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M218.437,292.652l12.078-45.262H180.232L169.3,292.652Z",
    transform: "translate(-29.726 -43.429)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M172.95,289.677h44.916L228.32,249.93H183.173Z",
    transform: "translate(-30.367 -43.875)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1029",
    "data-name": "Rectangle 1029",
    width: 3.248,
    height: 155.261,
    transform: "translate(101.575 258.499)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 3.248,
    height: 154.816,
    transform: "translate(104.832 258.944)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1031",
    "data-name": "Rectangle 1031",
    width: 3.248,
    height: 155.261,
    transform: "translate(301.925 258.499)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1032",
    "data-name": "Rectangle 1032",
    width: 3.248,
    height: 154.816,
    transform: "translate(305.182 258.944)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1033",
    "data-name": "Rectangle 1033",
    width: 247.014,
    height: 12.738,
    transform: "translate(87.543 249.479)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1034",
    "data-name": "Rectangle 1034",
    width: 108.745,
    height: 21.081,
    transform: "translate(194.812 262.217)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M307.1,328.544a2.424,2.424,0,1,1-2.424-2.424A2.424,2.424,0,0,1,307.1,328.544Z",
    transform: "translate(-53.065 -57.25)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M84.862,388.531h42.715a5.441,5.441,0,0,0,5.441-5.441V369.9a9.168,9.168,0,0,0-9.176-9.168H84.54Z",
    transform: "translate(-14.846 -63.325)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M117.109,402.734H33.122A4.122,4.122,0,0,1,29,398.612h0a4.122,4.122,0,0,1,4.122-4.122h83.987a4.122,4.122,0,0,1,4.122,4.122h0a4.122,4.122,0,0,1-4.122,4.122Z",
    transform: "translate(-5.096 -69.252)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M10.917,260.534l46.169-.824L86.42,370.558l-62.51.627-23.6-97.17a10.907,10.907,0,0,1,10.6-13.48Z",
    transform: "translate(-0.007 -45.592)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M38.206,404.49,24.38,484.833h3.792L46.343,404.49Z",
    transform: "translate(-4.285 -71.007)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M77.562,404.49,62.87,484.833h3.784L85.7,404.49Z",
    transform: "translate(-11.042 -71.007)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M122.677,404.49l16.39,80.343h-3.792L114.54,404.49Z",
    transform: "translate(-20.113 -71.007)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M62.87,259.71,85.732,370.673h17.536L84.932,272.629A15.788,15.788,0,0,0,69.408,259.71Z",
    transform: "translate(-11.042 -45.592)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M260.386,0V52.971H184.305L181.56.371Z",
    transform: "translate(-31.878)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1035",
    "data-name": "Rectangle 1035",
    width: 52.493,
    height: 76.08,
    transform: "translate(149.682 52.856) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M257.928,53.218h-76.8V0h76.8Zm-76.08-.717H257.21V.734H181.847Z",
    transform: "translate(-31.803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1036",
    "data-name": "Rectangle 1036",
    width: 59.6,
    height: 39.45,
    transform: "translate(157.926 6.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M251.1,8.323h-4.444l-12.276.049-42.872.082.173-.173V47.724h0l-.19-.181h59.6l-.148.148c0-12,.058-21.84.074-28.7,0-3.421,0-6.1.041-7.931V18.9c0,6.876.049,16.753.082,28.79v.157H191.2v-.082h0V8.15h.173l43.012.082,12.243.049h4.065Z",
    transform: "translate(-33.57 -1.431)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M181.56.27a6.366,6.366,0,0,1,1.311.824c.775.561,1.839,1.36,2.985,2.275s2.152,1.781,2.861,2.473A5.854,5.854,0,0,1,189.8,6.956,50.7,50.7,0,0,1,185.616,3.7,42.8,42.8,0,0,1,181.56.27Z",
    transform: "translate(-31.878 -0.047)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M272.088.45a35.951,35.951,0,0,1-3.99,3.4,36.143,36.143,0,0,1-4.238,3.116,35.947,35.947,0,0,1,4-3.4A36.15,36.15,0,0,1,272.088.45Z",
    transform: "translate(-46.326 -0.079)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M271.964,62.656,263.48,55.78",
    transform: "translate(-46.259 -9.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M263.48,55.78a40.217,40.217,0,0,1,4.361,3.3,40.783,40.783,0,0,1,4.122,3.578,39.445,39.445,0,0,1-4.361-3.3,39.056,39.056,0,0,1-4.122-3.578Z",
    transform: "translate(-46.259 -9.792)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M181.56,62.734a37.378,37.378,0,0,1,3.966-3.389,35.446,35.446,0,0,1,4.2-3.075,37.268,37.268,0,0,1-3.966,3.372,35.452,35.452,0,0,1-4.2,3.092Z",
    transform: "translate(-31.878 -9.878)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1037",
    "data-name": "Rectangle 1037",
    width: 13.208,
    height: 37.504,
    transform: "translate(170.021 32.384) rotate(-90)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1038",
    "data-name": "Rectangle 1038",
    width: 68.504,
    height: 113.395,
    transform: "translate(370.149 24.313)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1039",
    "data-name": "Rectangle 1039",
    width: 68.504,
    height: 113.395,
    transform: "translate(367.873 24.313)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1040",
    "data-name": "Rectangle 1040",
    width: 62.675,
    height: 108.795,
    transform: "translate(370.792 26.613)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1041",
    "data-name": "Rectangle 1041",
    width: 38.535,
    height: 80.524,
    transform: "translate(382.722 40.744)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M464.22,106.205c-.091-7.519,6.678-14.84,14.123-15.912,3.553-.5,7.329.2,10.644-1.162,5.928-2.424,7.808-10.3,13.768-12.631l.272,58.2H464.22Z",
    transform: "translate(-81.498 -13.429)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 2.366,
    height: 21.114,
    transform: "translate(12.023 92.413)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 2.366,
    height: 21.114,
    transform: "translate(89.786 92.413)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 98.893,
    height: 8.492,
    transform: "translate(3.309 83.929)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 13.636,
    height: 63.549,
    transform: "translate(69.026 20.38)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M94.458,82.721a2.7,2.7,0,1,1-.781-1.922,2.7,2.7,0,0,1,.781,1.922Z",
    transform: "translate(-15.638 -14.044)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    width: 4.172,
    height: 25.97,
    transform: "translate(73.923 37.216)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 13.636,
    height: 63.549,
    transform: "translate(55.183 20.38)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M77.658,82.721a2.7,2.7,0,1,1-.781-1.922A2.7,2.7,0,0,1,77.658,82.721Z",
    transform: "translate(-12.689 -14.044)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    width: 4.172,
    height: 25.97,
    transform: "translate(60.072 37.216)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    width: 13.636,
    height: 63.549,
    transform: "translate(41.992 20.38)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M61.668,82.721a2.7,2.7,0,1,1-.786-1.923A2.7,2.7,0,0,1,61.668,82.721Z",
    transform: "translate(-9.882 -14.044)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1050",
    "data-name": "Rectangle 1050",
    width: 4.172,
    height: 25.97,
    transform: "translate(46.881 37.216)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M29.2,88.189,45.58,32.283,39.932,29.81,23.13,86.161Z",
    transform: "translate(-4.066 -5.233)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M469.474,454.3H396.1a20.958,20.958,0,0,1-20.974-20.949L375,253.754a20.974,20.974,0,0,1,20.949-20.982l73.376-.041A20.966,20.966,0,0,1,490.3,253.679l.124,179.615A20.974,20.974,0,0,1,469.474,454.3Z",
    transform: "translate(-65.836 -40.855)",
    fill: "#2c2858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M471.389,451.753l-74.926.049a14.749,14.749,0,0,1-14.758-14.733l-.115-183.581a14.749,14.749,0,0,1,14.733-14.749l74.926-.049a14.749,14.749,0,0,1,14.758,14.733L486.122,437a14.749,14.749,0,0,1-14.733,14.749Z",
    transform: "translate(-66.993 -41.901)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M373.438,299h0a3.3,3.3,0,0,1-3.3-3.3v-16.91a3.3,3.3,0,0,1,3.3-3.3h0a3.3,3.3,0,0,1,3.3,3.3v16.959A3.3,3.3,0,0,1,373.438,299Z",
    transform: "translate(-64.983 -48.362)",
    fill: "#2c2858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M514.928,299h0a3.3,3.3,0,0,1-3.3-3.3v-16.91a3.3,3.3,0,0,1,3.3-3.3h0a3.3,3.3,0,0,1,3.3,3.3v16.959A3.3,3.3,0,0,1,514.928,299Z",
    transform: "translate(-89.821 -48.362)",
    fill: "#2c2858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M373.438,329.45h0a3.3,3.3,0,0,1-3.3-3.3V309.218a3.3,3.3,0,0,1,3.3-3.3h0a3.3,3.3,0,0,1,3.3,3.3v16.959A3.3,3.3,0,0,1,373.438,329.45Z",
    transform: "translate(-64.983 -53.704)",
    fill: "#2c2858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M476.869,475.509v3.776a2.671,2.671,0,0,1-2.671,2.671H428.069a2.671,2.671,0,0,1-2.68-2.671v-3.776a2.679,2.679,0,0,1,2.68-2.679H474.2a2.663,2.663,0,0,1,2.671,2.679Z",
    transform: "translate(-74.682 -83.004)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1051",
    "data-name": "Rectangle 1051",
    width: 1.344,
    height: 9.127,
    transform: "translate(353.264 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1052",
    "data-name": "Rectangle 1052",
    width: 1.344,
    height: 9.127,
    transform: "translate(358.887 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1053",
    "data-name": "Rectangle 1053",
    width: 1.344,
    height: 9.127,
    transform: "translate(364.501 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 1.344,
    height: 9.127,
    transform: "translate(370.124 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1055",
    "data-name": "Rectangle 1055",
    width: 1.344,
    height: 9.127,
    transform: "translate(375.747 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1056",
    "data-name": "Rectangle 1056",
    width: 1.344,
    height: 9.127,
    transform: "translate(381.361 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 1.344,
    height: 9.127,
    transform: "translate(386.984 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 1.344,
    height: 9.127,
    transform: "translate(392.599 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1059",
    "data-name": "Rectangle 1059",
    width: 1.344,
    height: 9.127,
    transform: "translate(398.221 389.826)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M476.377,473.8H426.16a2.663,2.663,0,0,1,2.045-.948h46.128a2.7,2.7,0,0,1,2.045.948Z",
    transform: "translate(-74.817 -83.008)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M476.377,482.75H426.16a2.638,2.638,0,0,0,2.045.948h46.128a2.663,2.663,0,0,0,2.045-.948Z",
    transform: "translate(-74.817 -84.746)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M480.789,464.429v3.776a2.679,2.679,0,0,1-2.679,2.671H431.981a2.671,2.671,0,0,1-2.671-2.671v-3.776a2.663,2.663,0,0,1,2.671-2.679h46.128a2.68,2.68,0,0,1,2.679,2.68Z",
    transform: "translate(-75.37 -81.059)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1060",
    "data-name": "Rectangle 1060",
    width: 1.344,
    height: 9.127,
    transform: "translate(356.496 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1061",
    "data-name": "Rectangle 1061",
    width: 1.344,
    height: 9.127,
    transform: "translate(362.11 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1062",
    "data-name": "Rectangle 1062",
    width: 1.344,
    height: 9.127,
    transform: "translate(367.733 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1063",
    "data-name": "Rectangle 1063",
    width: 1.344,
    height: 9.127,
    transform: "translate(373.348 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1064",
    "data-name": "Rectangle 1064",
    width: 1.344,
    height: 9.127,
    transform: "translate(378.97 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1065",
    "data-name": "Rectangle 1065",
    width: 1.344,
    height: 9.127,
    transform: "translate(384.585 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1066",
    "data-name": "Rectangle 1066",
    width: 1.344,
    height: 9.127,
    transform: "translate(390.208 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1067",
    "data-name": "Rectangle 1067",
    width: 1.344,
    height: 9.127,
    transform: "translate(395.83 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1068",
    "data-name": "Rectangle 1068",
    width: 1.344,
    height: 9.127,
    transform: "translate(401.445 380.699)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M480.3,462.708H430.07a2.7,2.7,0,0,1,2.045-.948h46.128a2.68,2.68,0,0,1,2.061.948Z",
    transform: "translate(-75.503 -81.061)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M480.3,471.68H430.07a2.663,2.663,0,0,0,2.045.948h46.128A2.655,2.655,0,0,0,480.3,471.68Z",
    transform: "translate(-75.503 -82.802)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M477.742,453.431v3.784a2.671,2.671,0,0,1-2.671,2.671H428.9a2.671,2.671,0,0,1-2.671-2.671v-3.784a2.68,2.68,0,0,1,2.671-2.671h46.169a2.663,2.663,0,0,1,2.671,2.671Z",
    transform: "translate(-74.829 -79.13)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1069",
    "data-name": "Rectangle 1069",
    width: 1.344,
    height: 9.127,
    transform: "translate(353.989 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1070",
    "data-name": "Rectangle 1070",
    width: 1.344,
    height: 9.127,
    transform: "translate(359.612 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    width: 1.344,
    height: 9.127,
    transform: "translate(365.227 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1072",
    "data-name": "Rectangle 1072",
    width: 1.344,
    height: 9.127,
    transform: "translate(370.85 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1073",
    "data-name": "Rectangle 1073",
    width: 1.344,
    height: 9.127,
    transform: "translate(376.464 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1074",
    "data-name": "Rectangle 1074",
    width: 1.344,
    height: 9.127,
    transform: "translate(382.087 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1075",
    "data-name": "Rectangle 1075",
    width: 1.344,
    height: 9.127,
    transform: "translate(387.71 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1076",
    "data-name": "Rectangle 1076",
    width: 1.344,
    height: 9.127,
    transform: "translate(393.324 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1077",
    "data-name": "Rectangle 1077",
    width: 1.344,
    height: 9.127,
    transform: "translate(398.947 371.589)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M477.292,451.658H427a2.663,2.663,0,0,1,2.036-.948h46.169a2.7,2.7,0,0,1,2.086.948Z",
    transform: "translate(-74.964 -79.121)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M477.292,460.63H427a2.663,2.663,0,0,0,2.036.948h46.169a2.7,2.7,0,0,0,2.086-.948Z",
    transform: "translate(-74.964 -80.863)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M479.032,442.531v3.784a2.671,2.671,0,0,1-2.671,2.671H430.191a2.671,2.671,0,0,1-2.671-2.671v-3.784a2.679,2.679,0,0,1,2.671-2.671h46.169a2.679,2.679,0,0,1,2.671,2.671Z",
    transform: "translate(-75.056 -77.216)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1078",
    "data-name": "Rectangle 1078",
    width: 1.344,
    height: 9.127,
    transform: "translate(355.02 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1079",
    "data-name": "Rectangle 1079",
    width: 1.344,
    height: 9.127,
    transform: "translate(360.643 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1080",
    "data-name": "Rectangle 1080",
    width: 1.344,
    height: 9.127,
    transform: "translate(366.257 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081",
    "data-name": "Rectangle 1081",
    width: 1.344,
    height: 9.127,
    transform: "translate(371.88 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082",
    "data-name": "Rectangle 1082",
    width: 1.344,
    height: 9.127,
    transform: "translate(377.495 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083",
    "data-name": "Rectangle 1083",
    width: 1.344,
    height: 9.127,
    transform: "translate(383.117 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084",
    "data-name": "Rectangle 1084",
    width: 1.344,
    height: 9.127,
    transform: "translate(388.732 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1085",
    "data-name": "Rectangle 1085",
    width: 1.344,
    height: 9.127,
    transform: "translate(394.355 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1086",
    "data-name": "Rectangle 1086",
    width: 1.344,
    height: 9.127,
    transform: "translate(399.977 362.643)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M478.5,440.8H428.29a2.638,2.638,0,0,1,2.036-.948H476.5a2.638,2.638,0,0,1,2,.948Z",
    transform: "translate(-75.191 -77.215)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M478.5,449.78H428.29a2.663,2.663,0,0,0,2.036.948H476.5a2.663,2.663,0,0,0,2-.948Z",
    transform: "translate(-75.191 -78.958)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M472.037,431.291v3.784a2.679,2.679,0,0,1-2.679,2.671H423.221a2.671,2.671,0,0,1-2.671-2.671v-3.784a2.663,2.663,0,0,1,.627-1.723,2.7,2.7,0,0,1,2.045-.948h46.128a2.68,2.68,0,0,1,2.679,2.671Z",
    transform: "translate(-73.832 -75.243)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1087",
    "data-name": "Rectangle 1087",
    width: 1.344,
    height: 9.127,
    transform: "translate(349.274 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1088",
    "data-name": "Rectangle 1088",
    width: 1.344,
    height: 9.127,
    transform: "translate(354.888 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1089",
    "data-name": "Rectangle 1089",
    width: 1.344,
    height: 9.127,
    transform: "translate(360.511 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1090",
    "data-name": "Rectangle 1090",
    width: 1.344,
    height: 9.127,
    transform: "translate(366.125 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1091",
    "data-name": "Rectangle 1091",
    width: 1.344,
    height: 9.127,
    transform: "translate(371.748 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1092",
    "data-name": "Rectangle 1092",
    width: 1.344,
    height: 9.127,
    transform: "translate(377.363 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1093",
    "data-name": "Rectangle 1093",
    width: 1.344,
    height: 9.127,
    transform: "translate(382.985 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 1.344,
    height: 9.127,
    transform: "translate(388.6 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095",
    "data-name": "Rectangle 1095",
    width: 1.344,
    height: 9.127,
    transform: "translate(394.223 353.377)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M471.527,429.568H421.31a2.7,2.7,0,0,1,2.045-.948h46.128a2.7,2.7,0,0,1,2.045.948Z",
    transform: "translate(-73.966 -75.243)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M471.527,438.54H421.31a2.663,2.663,0,0,0,2.045.948h46.128A2.663,2.663,0,0,0,471.527,438.54Z",
    transform: "translate(-73.966 -76.985)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M478.882,420.351v3.784a2.671,2.671,0,0,1-2.671,2.671H430.041a2.671,2.671,0,0,1-2.671-2.671v-3.784a2.663,2.663,0,0,1,2.671-2.671h46.169a2.68,2.68,0,0,1,2.671,2.671Z",
    transform: "translate(-75.029 -73.323)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1096",
    "data-name": "Rectangle 1096",
    width: 1.344,
    height: 9.127,
    transform: "translate(354.929 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1097",
    "data-name": "Rectangle 1097",
    width: 1.344,
    height: 9.127,
    transform: "translate(360.552 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1098",
    "data-name": "Rectangle 1098",
    width: 1.344,
    height: 9.127,
    transform: "translate(366.167 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1099",
    "data-name": "Rectangle 1099",
    width: 1.344,
    height: 9.127,
    transform: "translate(371.789 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1100",
    "data-name": "Rectangle 1100",
    width: 1.344,
    height: 9.127,
    transform: "translate(377.404 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1101",
    "data-name": "Rectangle 1101",
    width: 1.344,
    height: 9.127,
    transform: "translate(383.027 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 1.344,
    height: 9.127,
    transform: "translate(388.641 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 1.344,
    height: 9.127,
    transform: "translate(394.264 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 1.344,
    height: 9.127,
    transform: "translate(399.878 344.357)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M478.387,418.628H428.17a2.7,2.7,0,0,1,2.045-.948h46.169a2.663,2.663,0,0,1,2,.948Z",
    transform: "translate(-75.17 -73.323)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M478.387,427.6H428.17a2.7,2.7,0,0,0,2.045.948h46.169a2.663,2.663,0,0,0,2-.948Z",
    transform: "translate(-75.17 -75.064)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M476.454,409.249v3.776a2.679,2.679,0,0,1-2.671,2.679H427.655A2.688,2.688,0,0,1,425,413.025v-3.776a2.68,2.68,0,0,1,2.679-2.679h46.128a2.663,2.663,0,0,1,2.671,2.679Z",
    transform: "translate(-74.613 -71.372)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 1.344,
    height: 9.127,
    transform: "translate(352.926 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 1.344,
    height: 9.127,
    transform: "translate(358.54 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 1.344,
    height: 9.127,
    transform: "translate(364.163 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 1.344,
    height: 9.127,
    transform: "translate(369.778 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 1.344,
    height: 9.127,
    transform: "translate(375.4 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1110",
    "data-name": "Rectangle 1110",
    width: 1.344,
    height: 9.127,
    transform: "translate(381.015 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    width: 1.344,
    height: 9.127,
    transform: "translate(386.638 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1112",
    "data-name": "Rectangle 1112",
    width: 1.344,
    height: 9.127,
    transform: "translate(392.252 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 1.344,
    height: 9.127,
    transform: "translate(397.875 335.198)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M475.957,407.518H425.74a2.7,2.7,0,0,1,2.045-.948h46.128A2.7,2.7,0,0,1,475.957,407.518Z",
    transform: "translate(-74.743 -71.372)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M475.957,416.5H425.74a2.7,2.7,0,0,0,2.045.948h46.128A2.7,2.7,0,0,0,475.957,416.5Z",
    transform: "translate(-74.743 -73.116)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M479.8,398.239v3.776a2.68,2.68,0,0,1-2.68,2.68H430.991a2.679,2.679,0,0,1-2.671-2.679v-3.776a2.663,2.663,0,0,1,2.671-2.68h46.128A2.68,2.68,0,0,1,479.8,398.239Z",
    transform: "translate(-75.196 -69.44)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1114",
    "data-name": "Rectangle 1114",
    width: 1.344,
    height: 9.127,
    transform: "translate(355.68 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1115",
    "data-name": "Rectangle 1115",
    width: 1.344,
    height: 9.127,
    transform: "translate(361.302 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1116",
    "data-name": "Rectangle 1116",
    width: 1.344,
    height: 9.127,
    transform: "translate(366.917 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1117",
    "data-name": "Rectangle 1117",
    width: 1.344,
    height: 9.127,
    transform: "translate(372.54 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1118",
    "data-name": "Rectangle 1118",
    width: 1.344,
    height: 9.127,
    transform: "translate(378.154 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1119",
    "data-name": "Rectangle 1119",
    width: 1.344,
    height: 9.127,
    transform: "translate(383.777 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1120",
    "data-name": "Rectangle 1120",
    width: 1.344,
    height: 9.127,
    transform: "translate(389.391 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1121",
    "data-name": "Rectangle 1121",
    width: 1.344,
    height: 9.127,
    transform: "translate(395.014 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1122",
    "data-name": "Rectangle 1122",
    width: 1.344,
    height: 9.127,
    transform: "translate(400.629 326.12)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M479.306,396.508H429.08a2.7,2.7,0,0,1,2.045-.948h46.128a2.663,2.663,0,0,1,2.053.948Z",
    transform: "translate(-75.33 -69.44)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M479.306,405.49H429.08a2.7,2.7,0,0,0,2.045.948h46.128a2.663,2.663,0,0,0,2.053-.948Z",
    transform: "translate(-75.33 -71.183)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_259",
    "data-name": "Ellipse 259",
    cx: 27.528,
    cy: 27.528,
    r: 27.528,
    transform: "matrix(0.95, -0.313, 0.313, 0.95, 316.944, 354.327)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M443.3,453.144a22.615,22.615,0,0,1-37.1,9.44,22.37,22.37,0,0,1-1.608-1.7,22.615,22.615,0,0,1,32.929-30.942,22.31,22.31,0,0,1,3.85,4.947,22.549,22.549,0,0,1,1.929,18.253Z",
    transform: "translate(-70.072 -74.35)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M435.76,428.413,404.6,460.9a22.68,22.68,0,0,1-5.392-15.879l20.438-21.329a22.672,22.672,0,0,1,16.085,4.724Z",
    transform: "translate(-70.08 -74.361)",
    fill: "#faee6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M442.871,436.253,412.8,467.582a22.527,22.527,0,0,1-5.1-3.652l31.329-32.64a22.31,22.31,0,0,1,3.842,4.963Z",
    transform: "translate(-71.576 -75.712)",
    fill: "#faee6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M427.021,424.073c-2.671-.28-3.158,0-4.361,2.358.3-2.638,0-3.133-2.35-4.361,2.671.28,3.158,0,4.361-2.35C424.391,422.35,424.655,422.836,427.021,424.073Z",
    transform: "translate(-73.79 -73.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M415.794,475.687c-2.251-.231-2.663,0-3.677,1.987.256-2.226,0-2.638-1.987-3.677,2.259.239,2.671,0,3.677-1.987C413.56,474.269,413.782,474.673,415.794,475.687Z",
    transform: "translate(-72.003 -82.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M441.816,259.3A30.216,30.216,0,1,1,411.6,289.557,30.216,30.216,0,0,1,441.816,259.3Zm0,58.94A28.724,28.724,0,1,0,413.1,289.557a28.724,28.724,0,0,0,28.716,28.683Z",
    transform: "translate(-72.261 -45.52)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M447.4,275.15a4.015,4.015,0,0,1,4.015,4.007V334.6a4.015,4.015,0,0,1-8.022,0V279.149a4.015,4.015,0,0,1,4.007-4Z",
    transform: "translate(-77.842 -48.302)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M443.611,271.15h.157a3.982,3.982,0,0,1,3.083,1.649l16.662,21.312a4.015,4.015,0,1,1-6.488,4.724L443.364,281.6l-12.812,17.478a4.015,4.015,0,1,1-6.093-5.219l16.1-21.337A4.007,4.007,0,0,1,443.611,271.15Z",
    transform: "translate(-74.328 -47.6)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M483.547,361.178l-12.68-6.818-1.072,2h0c-.519.965,1.913,3.3,5.433,5.178s6.793,2.646,7.313,1.649C482.591,363.132,483.547,361.178,483.547,361.178Z",
    transform: "translate(-82.465 -62.207)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M483.771,361.267c-.519.965-3.792.214-7.313-1.649s-5.953-4.213-5.433-5.178,3.793-.206,7.313,1.69S484.291,360.3,483.771,361.267Z",
    transform: "translate(-82.681 -62.148)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M415.427,393.71,402.59,395.8c.115.668.223,1.344.33,2.02h0c.157.973,3.174,1.294,6.736.717s6.324-1.839,6.167-2.811Z",
    transform: "translate(-70.679 -69.115)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M415.511,393.616c.165.973-2.6,2.234-6.159,2.811s-6.6.256-6.744-.717,2.605-2.234,6.167-2.811S415.355,392.643,415.511,393.616Z",
    transform: "translate(-70.682 -68.922)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M434.063,365.181,422.4,359.41l-.9,1.839h0c-.437.882,1.83,2.894,5.07,4.493s6.216,2.168,6.653,1.278C433.263,366.962,434.063,365.181,434.063,365.181Z",
    transform: "translate(-73.989 -63.094)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M434.262,365.25c-.437.882-3.413.313-6.653-1.286s-5.507-3.6-5.07-4.493,3.413-.313,6.653,1.286S434.7,364.36,434.262,365.25Z",
    transform: "translate(-74.172 -63.031)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M412.81,340.13l-13.43,2.185c.107.7.223,1.41.338,2.111h0c.165,1.022,3.3,1.36,7.057.75s6.6-1.921,6.447-2.943Z",
    transform: "translate(-70.116 -59.709)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M412.9,340.025c.165,1.022-2.721,2.341-6.455,2.952s-6.884.264-7.049-.758,2.721-2.333,6.447-2.943S412.738,338.995,412.9,340.025Z",
    transform: "translate(-70.118 -59.505)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M317.581,325.97l-18.567,13.158-58.363,41.379-6.051,4.279,4.6,6.546,25.525,36.325,44.636-31.708,22.722-16.143.264-.181,2.3-29.359Z",
    transform: "translate(-41.189 -57.223)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M334.719,364.133l-11.542-16.44a8.822,8.822,0,0,1-12.284-2.144l-54.109,38.527a8.83,8.83,0,0,1-2.144,12.293l11.542,16.44a8.822,8.822,0,0,1,12.284,2.144l54.109-38.527a8.813,8.813,0,0,1,2.144-12.293Z",
    transform: "translate(-44.707 -60.661)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M315.011,374.734a14.642,14.642,0,1,0-3.562,20.4,14.642,14.642,0,0,0,3.562-20.4Z",
    transform: "translate(-50.631 -64.691)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M352.432,355.44l-16.522,15.8,13.958,13.735.231.239.033-.42Z",
    transform: "translate(-58.974 -62.397)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M344.039,392.443,335.91,374.61l13.958,13.735Z",
    transform: "translate(-58.974 -65.762)",
    fill: "#193f1e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M352.432,355.1,335.91,370.9,351.3,353.49Z",
    transform: "translate(-58.974 -62.054)",
    fill: "#193f1e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M299.994,341.93l-58.371,41.379-1.443,10.825,25.558,36.325,44.636-31.708-2.284-8.632c-.824-3.3-6.645-4.708-13.966-3.883Z",
    transform: "translate(-42.169 -60.025)",
    fill: "#193f1e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1123",
    "data-name": "Rectangle 1123",
    width: 122.332,
    height: 52.386,
    transform: "translate(189.916 373.305) rotate(-82.41)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M283.33,321.575l-19.894-2.655a8.822,8.822,0,0,1-9.893,7.577L242,412.784a8.83,8.83,0,0,1,7.577,9.893L269.5,425.34a8.822,8.822,0,0,1,9.893-7.577l11.542-86.287a8.822,8.822,0,0,1-7.61-9.9Z",
    transform: "translate(-42.488 -55.986)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_260",
    "data-name": "Ellipse 260",
    cx: 14.642,
    cy: 14.642,
    r: 14.642,
    transform: "translate(207.652 328.099) rotate(-78.53)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M283.634,400.484l-49.9,13.191,13.414,50.63,49.9-13.191-9.448-35.6c9.968-2.671,17.149-8.146,16.06-12.268s-10.034-5.334-20.018-2.737Z",
    transform: "translate(-41.036 -70.069)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1124",
    "data-name": "Rectangle 1124",
    width: 36.861,
    height: 58.008,
    transform: "matrix(-0.255, -0.967, 0.967, -0.255, 215.88, 383.64)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_261",
    "data-name": "Ellipse 261",
    cx: 13.076,
    cy: 13.076,
    r: 13.076,
    transform: "matrix(0.839, -0.544, 0.544, 0.839, 217.893, 355.398)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M293.172,400.479l-5.112,1.344,13.364,50.654,23.151-6.109-11.386-43.152c-1.088-4.122-10.034-5.334-20.018-2.737Z",
    transform: "translate(-50.574 -70.063)",
    fill: "#193f1e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M315.12,404.09c1.088,4.122-6.093,9.6-16.06,12.268l13.373,50.654h0c9.968-2.671,17.14-8.146,16.06-12.268Z",
    transform: "translate(-52.505 -70.937)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M320.08,415.18c.478,1.822-.75,3.867-3.009,5.45a5.178,5.178,0,0,1-3.52,6.315h0l6.761,25.616h0a5.128,5.128,0,0,1,5.953,3.092c2.292-1.583,3.545-3.644,3.059-5.483Z",
    transform: "translate(-55.049 -72.884)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M244.234,454.293H170.858a20.966,20.966,0,0,1-20.982-20.949L149.76,253.7a20.974,20.974,0,0,1,20.958-20.982l73.376-.041a20.966,20.966,0,0,1,20.974,20.949l.115,179.656a20.974,20.974,0,0,1-20.949,21.007Z",
    transform: "translate(-26.296 -40.846)",
    fill: "#2c2858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M246.141,451.753l-74.926.049a14.749,14.749,0,0,1-14.749-14.733l-.115-183.581a14.749,14.749,0,0,1,14.733-14.749l74.926-.049a14.741,14.741,0,0,1,14.758,14.733L260.882,437A14.741,14.741,0,0,1,246.141,451.753Z",
    transform: "translate(-27.452 -41.901)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M148.2,299h0a3.3,3.3,0,0,1-3.3-3.3v-16.91a3.3,3.3,0,0,1,3.3-3.3h0a3.3,3.3,0,0,1,3.3,3.3v16.959A3.3,3.3,0,0,1,148.2,299Z",
    transform: "translate(-25.442 -48.362)",
    fill: "#2c2858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M289.678,299h0a3.3,3.3,0,0,1-3.3-3.3v-16.91a3.3,3.3,0,0,1,3.3-3.3h0a3.3,3.3,0,0,1,3.3,3.3v16.959A3.3,3.3,0,0,1,289.678,299Z",
    transform: "translate(-50.279 -48.362)",
    fill: "#2c2858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M214.116,330.3a30.216,30.216,0,1,1,30.216-30.216A30.216,30.216,0,0,1,214.116,330.3Zm0-58.94a28.724,28.724,0,1,0,28.724,28.724,28.724,28.724,0,0,0-28.724-28.724Z",
    transform: "translate(-32.289 -47.375)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M219.7,313.806a4.015,4.015,0,0,1-4.015-4.015V254.355a4.015,4.015,0,1,1,8.03,0v55.436a4.015,4.015,0,0,1-4.015,4.015Z",
    transform: "translate(-37.868 -43.947)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M216.48,325.03h-.157a4.015,4.015,0,0,1-3.083-1.649l-16.654-21.337a4.01,4.01,0,0,1,6.48-4.724l13.669,17.231,12.8-17.478a4.015,4.015,0,1,1,6.1,5.211l-16.11,21.345A4.015,4.015,0,0,1,216.48,325.03Z",
    transform: "translate(-34.381 -51.881)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1125",
    "data-name": "Rectangle 1125",
    width: 94.548,
    height: 30.332,
    rx: 15.166,
    transform: "translate(134.298 295.203)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M193.311,370.4v8.533a4.122,4.122,0,0,1-4.163,4.163H173.013a4.172,4.172,0,0,1-4.163-4.164V370.4a4.122,4.122,0,0,1,4.163-4.122h16.135a4.122,4.122,0,0,1,4.163,4.122Z",
    transform: "translate(-29.647 -64.3)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M231.979,379.182H205.2a3.471,3.471,0,0,1-3.471-3.471h0a3.479,3.479,0,0,1,3.471-3.471h26.778a3.471,3.471,0,0,1,3.471,3.471h0a3.463,3.463,0,0,1-3.471,3.471Z",
    transform: "translate(-35.419 -65.346)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M263.823,379.182H250.4a3.471,3.471,0,0,1-3.471-3.471h0a3.479,3.479,0,0,1,3.471-3.471h13.422a3.479,3.479,0,0,1,3.471,3.471h0a3.471,3.471,0,0,1-3.471,3.471Z",
    transform: "translate(-43.354 -65.346)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M191.654,367.071l-20.933,15.335a4.122,4.122,0,0,1-1.871-3.471V370.4a4.122,4.122,0,0,1,4.163-4.122h16.135a4.123,4.123,0,0,1,2.506.792Z",
    transform: "translate(-29.647 -64.299)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M190.806,380.263a2.8,2.8,0,1,1-2.8-2.8A2.8,2.8,0,0,1,190.806,380.263Z",
    transform: "translate(-32.517 -66.262)",
    fill: "#e62552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M194.806,380.263a2.8,2.8,0,1,1-2.8-2.8,2.8,2.8,0,0,1,2.8,2.8Z",
    transform: "translate(-33.219 -66.262)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1126",
    "data-name": "Rectangle 1126",
    width: 94.548,
    height: 30.332,
    rx: 15.166,
    transform: "translate(134.298 331.949)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M193.311,414.963V423.5a4.122,4.122,0,0,1-4.163,4.164H173.013a4.172,4.172,0,0,1-4.163-4.164v-8.533a4.122,4.122,0,0,1,4.163-4.163h16.135a4.163,4.163,0,0,1,4.163,4.163Z",
    transform: "translate(-29.647 -72.115)",
    fill: "#d6224c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M231.979,423.762H205.2a3.479,3.479,0,0,1-3.471-3.471h0a3.471,3.471,0,0,1,3.471-3.471h26.778a3.463,3.463,0,0,1,3.471,3.471h0A3.471,3.471,0,0,1,231.979,423.762Z",
    transform: "translate(-35.419 -73.172)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M263.823,423.762H250.4a3.479,3.479,0,0,1-3.471-3.471h0a3.471,3.471,0,0,1,3.471-3.471h13.422a3.471,3.471,0,0,1,3.471,3.471h0A3.479,3.479,0,0,1,263.823,423.762Z",
    transform: "translate(-43.354 -73.172)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M191.654,411.641l-20.933,15.327a4.122,4.122,0,0,1-1.871-3.471v-8.533a4.122,4.122,0,0,1,4.163-4.163h16.135a4.122,4.122,0,0,1,2.506.841Z",
    transform: "translate(-29.647 -72.115)",
    fill: "#e62552"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    cx: 2.803,
    cy: 2.803,
    r: 2.803,
    transform: "translate(152.546 348.034) rotate(-1.68)",
    fill: "#fac832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M194.806,424.835a2.8,2.8,0,1,1-2.8-2.795,2.8,2.8,0,0,1,2.8,2.795Z",
    transform: "translate(-33.219 -74.088)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1127",
    "data-name": "Rectangle 1127",
    width: 94.548,
    height: 30.332,
    rx: 15.166,
    transform: "translate(134.298 368.703)",
    fill: "#e3eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M193.311,459.533v8.533a4.172,4.172,0,0,1-4.163,4.172H173.013a4.172,4.172,0,0,1-4.163-4.172v-8.533a4.122,4.122,0,0,1,4.163-4.163h16.135a4.163,4.163,0,0,1,4.163,4.163Z",
    transform: "translate(-29.647 -79.939)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M231.979,468.332H205.2a3.471,3.471,0,0,1-3.471-3.471h0a3.471,3.471,0,0,1,3.471-3.471h26.778a3.463,3.463,0,0,1,3.471,3.471h0a3.463,3.463,0,0,1-3.471,3.471Z",
    transform: "translate(-35.419 -80.996)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M263.823,468.332H250.4a3.471,3.471,0,0,1-3.471-3.471h0a3.471,3.471,0,0,1,3.471-3.471h13.422a3.471,3.471,0,0,1,3.471,3.471h0A3.471,3.471,0,0,1,263.823,468.332Z",
    transform: "translate(-43.354 -80.996)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M191.654,456.211l-20.933,15.343a4.122,4.122,0,0,1-1.871-3.479v-8.541a4.122,4.122,0,0,1,4.163-4.163h16.135A4.123,4.123,0,0,1,191.654,456.211Z",
    transform: "translate(-29.647 -79.939)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M190.806,469.4a2.8,2.8,0,1,1-2.8-2.8A2.8,2.8,0,0,1,190.806,469.4Z",
    transform: "translate(-32.517 -81.911)",
    fill: "#e62552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M194.806,469.4a2.8,2.8,0,1,1-2.8-2.8,2.8,2.8,0,0,1,2.8,2.8Z",
    transform: "translate(-33.219 -81.911)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M14.862,192.884l10.042-.956a1.83,1.83,0,0,1,1.872,1.121L34.36,211.3a1.839,1.839,0,0,1-1.542,2.539l-10.454,1a1.839,1.839,0,0,1-1.888-1.154L13.3,195.391a1.847,1.847,0,0,1,1.558-2.506Z",
    transform: "translate(-2.319 -33.691)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M154.431,447.948l-5.326,2.828s-28.815-30.554-35.74-59.872a45.584,45.584,0,0,1-1.2-15.294s-.42-1.327-1.154-3.677l-.1-.313-1.13-3.611c-1.393-4.436-3.3-10.5-5.483-17.4-5.013-15.887-16.489-51.71-21.386-66.607l35.229-12.746s4,9.127,9.753,33.926c.882,3.24,1.773,6.818,2.6,10.718.94,4.419,1.822,9.25,2.548,14.461a221.777,221.777,0,0,1,2.111,29.68q0,6.662-.346,13.793a60.4,60.4,0,0,0,1.294,13.4C140.531,411.376,154.431,447.948,154.431,447.948Z",
    transform: "translate(-14.56 -47.619)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M186.931,498.791H158.446s-1.064-4.543.824-7.634c1.649-2.737,1.022-4.3-.206-6.554a11.18,11.18,0,0,0,4.8.907A10.043,10.043,0,0,0,168.084,484c1.228,1.393,6.472,7.346,8.113,8.525C178.06,493.893,186.354,493.4,186.931,498.791Z",
    transform: "translate(-27.768 -84.965)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M133.037,330.408l-22.128,41.223-1.13-3.611c-1.393-4.436-3.3-10.5-5.483-17.4-5.013-15.887-16.489-51.71-21.386-66.608l35.229-12.746s4,9.127,9.753,33.926c.882,3.24,1.773,6.818,2.6,10.718C131.429,320.325,132.311,325.156,133.037,330.408Z",
    transform: "translate(-14.56 -47.621)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M24.585,229.2c-.181.157-8.624-8.475-13.125-13.257l4.51-2.745,24.659,15.5Z",
    transform: "translate(-2.017 -37.427)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M82.194,490.858a18.385,18.385,0,0,0,1.187,8.912H95.2s.082-3.52-2.919-7.939S82.194,490.858,82.194,490.858Z",
    transform: "translate(-14.413 -85.944)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M105.606,107.728c.165-.758,2.168-8.838,14.708-7.09,0,0-6.258-.338-7.783,2.168,0,0,4.749-2.6,7.964-.94s4.172,7.964,3.85,9.893-3.3,7.939-5.557,8.1a6.7,6.7,0,0,1-2.614-.453,29.68,29.68,0,0,1,1.154,3.3c3.2,11.072-3.669,20.158-7.684,18.319-2.581-1.179-4.122,3.3-4.122,3.3L83,118.545S96.076,100.283,105.606,107.728Z",
    transform: "translate(-14.576 -17.623)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M82.45,185.723A32.376,32.376,0,0,0,93.7,190.505c17.314,4.007,23.992-10.652,26.49-20.718a15,15,0,0,0-5.878-1.806c-1.253-.148-2.572-.239-3.669-.3-1.946-1.492-4.848-7.6-5.491-17.074l-.824.214-13.669,3.743s.627,4.345.94,8.451c.231,3.215.272,6.291-.338,7.041l-1.707.379a87.978,87.978,0,0,0-7.107,15.285Z",
    transform: "translate(-14.479 -26.439)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M92.42,154.625s.635,4.345.94,8.459c7.742-.824,11.336-8.154,12.73-12.194Z",
    transform: "translate(-16.23 -26.488)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M87.995,153.649s18.377-1.014,17.569-12.449,1.022-19.276-10.718-19.111-13.744,4.691-14.4,8.574S83.188,153.616,87.995,153.649Z",
    transform: "translate(-14.113 -21.432)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M80.2,123.765c2.589-3.644,4.79-3.042,6.068-2.094a12.864,12.864,0,0,1,16.687,1.459,21.947,21.947,0,0,0,8.071,12.367s-3.2,2.308-11.056.874a13.482,13.482,0,0,1-6.6-3.858,43.111,43.111,0,0,0,8.014,8.475c-9.514-3.6-14.139-16.151-14.6-17.478-1.047,1.08-3.1,3.43-3.619,5.623-.709,2.976-.693,9-2.473,8.921C80.753,138.078,76.317,129.231,80.2,123.765Z",
    transform: "translate(-13.805 -20.931)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M81.3,173.047s29.944-7.272,42.97,3.463l-6.513,90.756L59.22,253.11S60.869,247.339,72.1,232.1,78.421,194.434,81.3,173.047Z",
    transform: "translate(-10.401 -29.956)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M98.084,274a6.035,6.035,0,0,1-.1.9c0,.247-.058.552-.1.907-.256,2.358-.726,6.868-1.344,12.738-1.608,15.393-4.122,40.11-5.845,59.616-1.344,15.228-2.2,27.331-1.74,29.243,1.385,5.837,0,75.578,0,75.578-4.947,2.391-12.523,0-12.523,0s-13.257-62.823-11.4-71.554a30.068,30.068,0,0,0-1.245-16.192C53.5,317.29,54.627,290.718,56.7,278a54.613,54.613,0,0,1,1.723-7.775,16.159,16.159,0,0,1,.75-1.9A48.4,48.4,0,0,1,98.084,274Z",
    transform: "translate(-9.716 -46.796)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M117.375,284.431a57.71,57.71,0,0,1-20.537,4.444,69.013,69.013,0,0,1-16.9-1.649A77.672,77.672,0,0,1,57,278.33a54.61,54.61,0,0,1,1.723-7.775c6.917-4.947,24.008-.214,37.974,5.013l1.484.561C108.875,280.227,117.375,284.431,117.375,284.431Z",
    transform: "translate(-10.012 -47.129)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M121.541,202.545c-1.443,10.916-7.23,24.272-9.292,31.469,0,0,3.454,24.964.157,31.816A3.051,3.051,0,0,1,111,267.4c-12.21,5.326-59.765.157-61.776-15.186-.726-5.573,18.138-25.179,19.218-27.553.453-.989.94-4.18-1.27-10.792-3.133,9.663-8.912,20.809-14.733,22.705-6.389,2.094-31.675-16.745-31.675-16.745s-.14-2.284,3.05-4.452c2.053-1.393,6.777-1.863,6.777-1.863l16.168,7.239c2.028-3.471,7.082-27.487,12.721-38.329,4.246-8.146,15.574-9.325,15.574-9.325s4.716,7.478,16.118,6.414,13.488-8.038,13.488-8.038,10.108,1.344,13.191,3.858C118.441,175.775,123.454,188.241,121.541,202.545Z",
    transform: "translate(-3.65 -30.103)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M128.032,240.629s3.454,24.964.157,31.816c-8.9-4.46-20.5-14.1-16.967-29.161,5.128-21.889,26.086-34.124,26.086-34.124C135.881,220.076,130.094,233.432,128.032,240.629Z",
    transform: "translate(-19.416 -36.718)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M118.753,227s-12.664,1.839-13.678,2.778-4.5,6.439-4.073,8.352.387,3.883,1.162,3.743,3.3-4.947,4.254-5.211,1.748-.882,1.863-.453-1.946,2.473-1.839,3.05,1.723-.1,2.473-1.228,2.548-1.649,2.82-2.383,1.525-3.026,3.232-2.919S118.753,227,118.753,227Z",
    transform: "translate(-17.73 -39.849)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M133.959,226.37l-12.317.495-4.221,5.746,16.761.561Z",
    transform: "translate(-20.618 -39.739)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M122.539,171.48s14.683,1.74,18.732,8.038c5.112,7.964,23.175,34.371,22.788,42.36,0,0-11.254,4.485-41.511,2.086,0,0-.544-4.576,5.771-8.245,0,0,16.242-2.218,18.039-3.8l-12.02-12.8Z",
    transform: "translate(-21.516 -30.103)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M12.2,193.125l10.042-.956a1.839,1.839,0,0,1,1.863,1.13l7.585,18.245a1.847,1.847,0,0,1-1.525,2.539L19.73,215.113a1.847,1.847,0,0,1-1.888-1.162l-7.181-18.295a1.847,1.847,0,0,1,1.542-2.531Z",
    transform: "translate(-1.853 -33.733)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M10.931,213.687s-2.655-4.576-2.473-5.705,2.943-6.348,4.353-6.868c2.523-.932,6.051-1.5,5.087,1.146-.643,1.756-3.182,4.287-2.745,5.087s.272,3.595.272,3.595Z",
    transform: "translate(-1.489 -35.169)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M414.212,229.781a1.492,1.492,0,0,1-1.492-1.492c0-1.212,0-2.473-.091-3.652a1.494,1.494,0,0,1,2.985-.148c.058,1.261.091,2.539.091,3.8A1.492,1.492,0,0,1,414.212,229.781Z",
    transform: "translate(-72.441 -39.159)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M382.84,204.018a1.492,1.492,0,0,1-1.468-1.261,71.268,71.268,0,0,0-1.525-7.23,1.494,1.494,0,1,1,2.885-.775,75.651,75.651,0,0,1,1.583,7.544A1.492,1.492,0,0,1,383.079,204Zm-142.449-.066a1.172,1.172,0,0,1-.239,0,1.484,1.484,0,0,1-1.237-1.707,72.82,72.82,0,0,1,1.591-7.535,1.493,1.493,0,1,1,2.886.767,72.245,72.245,0,0,0-1.533,7.23,1.484,1.484,0,0,1-1.468,1.245Zm138.566-14.5a1.5,1.5,0,0,1-1.393-.965,70.484,70.484,0,0,0-3.009-6.752,1.493,1.493,0,1,1,2.663-1.352,72.527,72.527,0,0,1,3.133,7.041,1.492,1.492,0,0,1-1.393,2.028Zm-134.674-.058a1.574,1.574,0,0,1-.536-.1,1.5,1.5,0,0,1-.824-1.929,74.562,74.562,0,0,1,3.141-7.033,1.493,1.493,0,0,1,2.663,1.352,70.53,70.53,0,0,0-3.018,6.752A1.484,1.484,0,0,1,244.283,189.393Zm127.79-13.381a1.492,1.492,0,0,1-1.253-.684,71.2,71.2,0,0,0-4.345-5.977,1.492,1.492,0,1,1,2.317-1.88,74.16,74.16,0,0,1,4.534,6.233,1.492,1.492,0,0,1-.437,2.069,1.558,1.558,0,0,1-.783.239Zm-120.964-.041a1.558,1.558,0,0,1-.824-.239,1.5,1.5,0,0,1-.437-2.069,74.516,74.516,0,0,1,4.535-6.225,1.492,1.492,0,1,1,2.317,1.88,70.386,70.386,0,0,0-4.345,5.977,1.5,1.5,0,0,1-1.212.676ZM362.65,164.3a1.476,1.476,0,0,1-1.055-.445c-1.74-1.731-3.586-3.4-5.491-4.947a1.492,1.492,0,1,1,1.88-2.317,72.142,72.142,0,0,1,5.722,5.161,1.492,1.492,0,0,1-1.055,2.548Zm-101.977,0a1.492,1.492,0,0,1-1.055-2.548,75.331,75.331,0,0,1,5.722-5.161,1.495,1.495,0,0,1,1.88,2.325,70.789,70.789,0,0,0-5.491,4.947,1.517,1.517,0,0,1-1.088.4Zm90.269-9.473a1.493,1.493,0,0,1-.824-.239,71.569,71.569,0,0,0-6.4-3.7,1.492,1.492,0,0,1,1.36-2.655,73.656,73.656,0,0,1,6.67,3.858,1.492,1.492,0,0,1-.824,2.737Zm-78.554,0a1.492,1.492,0,0,1-.824-2.745,74.546,74.546,0,0,1,6.678-3.85,1.492,1.492,0,0,1,1.352,2.655,69.612,69.612,0,0,0-6.4,3.7,1.492,1.492,0,0,1-.841.181ZM337.52,148a1.542,1.542,0,0,1-.536-.1,70.538,70.538,0,0,0-7.024-2.292,1.492,1.492,0,0,1,.767-2.877,71.731,71.731,0,0,1,7.329,2.383A1.492,1.492,0,0,1,337.52,148Zm-51.693,0a1.492,1.492,0,0,1-.536-2.886,73.72,73.72,0,0,1,7.329-2.374,1.492,1.492,0,1,1,.775,2.877,70.787,70.787,0,0,0-7.041,2.284,1.492,1.492,0,0,1-.561.016Zm37.1-3.875a1.1,1.1,0,0,1-.231,0,73.121,73.121,0,0,0-7.354-.767,1.492,1.492,0,1,1,.148-2.976,74.344,74.344,0,0,1,7.667.824,1.492,1.492,0,0,1,1.245,1.707,1.509,1.509,0,0,1-1.476,1.13Zm-22.574,0a1.492,1.492,0,0,1-.223-2.968,74.193,74.193,0,0,1,7.659-.824,1.494,1.494,0,1,1,.157,2.984,70.313,70.313,0,0,0-7.354.758,1.179,1.179,0,0,1-.239-.041Z",
    transform: "translate(-41.943 -24.634)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M239.322,229.781a1.492,1.492,0,0,1-1.492-1.492c0-1.261,0-2.539.091-3.8a1.494,1.494,0,0,1,2.985.148c-.066,1.212-.091,2.473-.091,3.652a1.492,1.492,0,0,1-1.492,1.492Z",
    transform: "translate(-41.756 -39.159)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M263.822,229.781a1.492,1.492,0,0,1-1.492-1.492c0-1.27.049-2.564.14-3.834a1.492,1.492,0,1,1,2.977.214c-.091,1.2-.132,2.416-.132,3.619a1.492,1.492,0,0,1-1.492,1.492Z",
    transform: "translate(-46.057 -39.159)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M265.252,208.507a1.394,1.394,0,0,1-.313,0,1.492,1.492,0,0,1-1.146-1.773,53.5,53.5,0,0,1,2.152-7.313,1.492,1.492,0,0,1,2.795,1.006,49.815,49.815,0,0,0-2.028,6.9,1.492,1.492,0,0,1-1.459,1.179Zm101.408,0a1.484,1.484,0,0,1-1.451-1.179,51.2,51.2,0,0,0-2.028-6.892,1.492,1.492,0,1,1,2.795-1.047,53.723,53.723,0,0,1,2.144,7.3,1.476,1.476,0,0,1-1.138,1.773,1.436,1.436,0,0,1-.3.008Zm-96.238-13.851a1.517,1.517,0,0,1-.717-.181,1.5,1.5,0,0,1-.594-2.028,53.99,53.99,0,0,1,4.122-6.406,1.492,1.492,0,1,1,2.383,1.8,50.607,50.607,0,0,0-3.891,6.043A1.492,1.492,0,0,1,270.421,194.657Zm91.094,0a1.492,1.492,0,0,1-1.311-.775,50.589,50.589,0,0,0-3.891-6.043,1.492,1.492,0,0,1,2.383-1.789,53.89,53.89,0,0,1,4.122,6.4,1.484,1.484,0,0,1-.594,2.02A1.418,1.418,0,0,1,361.515,194.657Zm-82.231-11.79a1.492,1.492,0,0,1-1.055-2.548A53.436,53.436,0,0,1,284,175.373a1.493,1.493,0,1,1,1.789,2.391,50.9,50.9,0,0,0-5.433,4.708,1.5,1.5,0,0,1-1.072.387Zm73.376,0a1.5,1.5,0,0,1-1.055-.437,50.9,50.9,0,0,0-5.433-4.708,1.493,1.493,0,0,1,1.789-2.391,55.086,55.086,0,0,1,5.771,4.988,1.492,1.492,0,0,1-1.055,2.548ZM291.1,174.045a1.492,1.492,0,0,1-.717-2.8,53.513,53.513,0,0,1,6.925-3.166,1.492,1.492,0,1,1,1.039,2.795,50.175,50.175,0,0,0-6.53,2.993A1.492,1.492,0,0,1,291.1,174.045Zm49.731,0a1.493,1.493,0,0,1-.717-.181,50.744,50.744,0,0,0-6.538-2.985,1.492,1.492,0,1,1,1.039-2.795,53.586,53.586,0,0,1,6.934,3.158,1.492,1.492,0,0,1-.717,2.8Zm-35.9-5.145a1.492,1.492,0,0,1-.313-2.952,53.854,53.854,0,0,1,7.536-1.08,1.5,1.5,0,0,1,.214,2.984,50.291,50.291,0,0,0-7.115,1.014,1.419,1.419,0,0,1-.322-.025Zm22.062,0a1.416,1.416,0,0,1-.322,0,51.337,51.337,0,0,0-7.115-1.014,1.492,1.492,0,1,1,.214-2.977,53.842,53.842,0,0,1,7.535,1.072,1.492,1.492,0,0,1-.313,2.952Z",
    transform: "translate(-46.308 -28.942)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M389.7,229.781a1.492,1.492,0,0,1-1.492-1.492c0-1.2-.041-2.424-.132-3.619a1.492,1.492,0,1,1,2.977-.214c.09,1.27.14,2.564.14,3.834a1.492,1.492,0,0,1-1.492,1.492Z",
    transform: "translate(-68.131 -39.159)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M412.007,229.146h0a.89.89,0,0,1-.726-.371l-9.531-12.812a.934.934,0,0,1,1.5-1.113l8.805,11.847,8.772-10.891a.932.932,0,0,1,1.451,1.171L412.749,228.8A.915.915,0,0,1,412.007,229.146Z",
    transform: "translate(-70.5 -37.65)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M261.887,229.146h0a.907.907,0,0,1-.726-.371l-9.531-12.812a.934.934,0,1,1,1.5-1.113l8.805,11.847,8.772-10.891a.932.932,0,0,1,1.451,1.171L262.621,228.8A.931.931,0,0,1,261.887,229.146Z",
    transform: "translate(-44.147 -37.65)",
    fill: "#95a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M259.817,142.282a17.017,17.017,0,1,1-8.764-22.417A17.017,17.017,0,0,1,259.817,142.282Z",
    transform: "translate(-39.892 -20.791)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M257.659,141.706a14.016,14.016,0,1,1-7.2-18.41A14.016,14.016,0,0,1,257.659,141.706Z",
    transform: "translate(-40.52 -21.435)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M254.7,140.448h-1.435v5.359H250.87l-3.578-5.359h-5.648v5.359H239.41v-5.359H238v-2.012h1.435v-2.844H238v-2.012h1.435V128.23h2.383l3.578,5.351h5.656V128.23h2.234v5.351h1.435v2.012h-1.435v2.844h1.435Zm-12-6.868L241.644,132v1.583Zm3.248,4.856-1.9-2.844h-2.407v2.844Zm5.079,0v-2.844h-4.3l1.9,2.844Zm0,3.595v-1.583h-1.055Z",
    transform: "translate(-41.786 -22.511)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M344.677,116.853a17.017,17.017,0,1,1-8.756-22.409,17.017,17.017,0,0,1,8.756,22.409Z",
    transform: "translate(-54.788 -16.327)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M342.519,116.276a14.016,14.016,0,1,1-7.2-18.41,14.016,14.016,0,0,1,7.2,18.41Z",
    transform: "translate(-55.417 -16.971)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M339.945,115.218h-1.435v5.359H336.12l-3.586-5.359h-5.647v5.359h-2.193v-5.359H323.25v-2.012h1.443v-2.844H323.25v-2.012h1.443V103h2.383l3.578,5.351h5.656V103h2.234v5.351h1.435v2.012h-1.435v2.844h1.435Zm-12-6.868-1.055-1.583v1.583Zm3.257,4.856-1.9-2.844h-2.416v2.844Zm5.079,0v-2.844h-4.3l1.9,2.844Zm0,3.595v-1.583h-1.055Z",
    transform: "translate(-56.751 -18.081)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 17.039,
    cy: 17.039,
    r: 17.039,
    transform: "translate(314.967 102.096) rotate(-8.616)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M415.189,141.706a14.016,14.016,0,1,1-7.2-18.41,14.016,14.016,0,0,1,7.2,18.41Z",
    transform: "translate(-68.174 -21.435)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M411.928,140.405h-1.435v5.359H408.1l-3.586-5.359h-5.647v5.359h-2.185v-5.359H395.2v-2.02h1.484v-2.836H395.2v-1.987h1.484V128.22h2.383l3.578,5.342h5.582V128.22h2.234v5.342H411.9v2.02h-1.435v2.836H411.9Zm-12-6.876-1.055-1.583v1.583Zm3.257,4.856-1.9-2.836h-2.416v2.836Zm5.079,0v-2.836h-4.3l1.9,2.836Zm0,3.6v-1.583H407.2Z",
    transform: "translate(-69.382 -22.509)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M459.4,202.137a17.017,17.017,0,1,1,.273-13.039A17.017,17.017,0,0,1,459.4,202.137Z",
    transform: "translate(-74.929 -31.295)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M457.3,201.571a13.974,13.974,0,1,1-7.2-18.4A13.975,13.975,0,0,1,457.3,201.571Z",
    transform: "translate(-75.582 -31.948)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M454.568,200.5h-1.443v5.359h-2.383l-3.586-5.359h-5.648v5.359h-2.226V200.5H437.84v-2.012h1.443v-2.844H437.84v-2.012h1.443V188.29h2.383l3.57,5.342H450.9V188.29h2.226v5.342h1.443v2.012h-1.443v2.844h1.443Zm-12-6.868-1.055-1.583v1.583Zm3.248,4.856-1.9-2.844h-2.407v2.844Zm5.087,0v-2.844h-4.3l1.9,2.844Zm0,3.595V200.5h-1.055Z",
    transform: "translate(-76.867 -33.054)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M222.8,202.137a17.017,17.017,0,1,1,.273-13.039,17.017,17.017,0,0,1-.273,13.039Z",
    transform: "translate(-33.395 -31.295)",
    fill: "#faba23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M220.658,201.571a13.974,13.974,0,1,1-7.2-18.4A13.974,13.974,0,0,1,220.658,201.571Z",
    transform: "translate(-34.04 -31.948)",
    fill: "#fad332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M217.436,200.5h-1.443v5.359h-2.383l-3.595-5.359h-5.648v5.359h-2.234V200.5H200.7v-2.012h1.435v-2.844H200.7v-2.012h1.435V188.29h2.391l3.57,5.342h5.664V188.29h2.226v5.342h1.451v2.012h-1.443v2.844h1.443Zm-12-6.868-1.055-1.583v1.583Zm3.248,4.856-1.9-2.844h-2.407v2.844Zm5.087,0v-2.844h-4.3l1.888,2.844Zm0,3.595V200.5h-1.055Z",
    transform: "translate(-35.238 -33.054)",
    fill: "#faba23"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetTransfer);
export default __webpack_public_path__ + "static/media/get-transfer.96a5c618f6d2daa63f33300c98c8e562.svg";
export { ForwardRef as ReactComponent };